// --------------------------------------------------------------
// Created On: 2022-10-31
// Author: Zachary Thomas
//
// Last Modified: 2025-02-24
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import { intervalToDuration } from "date-fns";

// Gets the amount of time since the specified date as a string describing the time passed.
export default function isoToTimePassed(isoUtcTime: string | null): string {
  if (isoUtcTime === null) {
    return `0 seconds`;
  } else {
    // Check that ISO string includes timezone info, otherwise assume UTC.
    const isoSplit = isoUtcTime.split("T");
    if (isoSplit.length > 1) {
      const isoAfterT = isoSplit[1];
      if (!isoAfterT.includes("Z") && !isoAfterT.includes("+") && !isoAfterT.includes("-")) {
        isoUtcTime += "Z";
      }
    }
    const localDate = new Date(isoUtcTime);
    const nowDate = new Date();
    nowDate.setHours(0);
    nowDate.setMinutes(0);
    nowDate.setSeconds(0);
    const nowTime = nowDate.getTime();
    const localTime = localDate.getTime();
    let millisecondsPassed = 0;
    // Calculate the difference between the two dates and add 1 second to round to the nearest day.
    if (nowTime > localTime) {
      millisecondsPassed = nowTime - localTime + 1000;
    } else {
      millisecondsPassed = localTime - nowTime + 1000;
    }
    const duration = intervalToDuration({ start: 0, end: millisecondsPassed });
    if (duration.years !== undefined && duration.years > 0) {
      return `${duration.years} year${duration.years > 1 ? "s" : ""}`;
    } else if (duration.months !== undefined && duration.months > 0) {
      return `${duration.months} month${duration.months > 1 ? "s" : ""}`;
    } else if (duration.weeks !== undefined && duration.weeks > 0) {
      return `${duration.weeks} week${duration.weeks > 1 ? "s" : ""}`;
    } else if (duration.days !== undefined && duration.days > 0) {
      return `${duration.days} day${duration.days > 1 ? "s" : ""}`;
    } else {
      return `1 day`;
    }
  }
}
